import { Box, List, Skeleton } from '@factorialco/deprecated-design-system'

export const LoadingSkeletonResumeBox = () => {
  return (
    <Box width="s360">
      <List>
        <Box padding="s24" gap="s24">
          <Skeleton width="s200" height="s16" isLoading />
          <Skeleton width="s32" height="s32" isLoading />

          <Box flexDirection="row" justifyContent="spaceBetween">
            <Skeleton width="s200" height="s16" isLoading />
            <Skeleton width="s16" height="s16" isLoading />
          </Box>

          <Box flexDirection="row" justifyContent="spaceBetween">
            <Skeleton width="s200" height="s16" isLoading />
            <Skeleton width="s16" height="s16" isLoading />
          </Box>
        </Box>
      </List>
    </Box>
  )
}
